import { z } from 'zod';
import { FeaturesSchema } from './features';

export const SubscriptionPlanNameSchema = z.enum([ 'free', 'pilot', 'pro', 'agency', 'enterprise' ]);
export type SubscriptionPlanName = z.infer<typeof SubscriptionPlanNameSchema>;

export const SubscriptionPlanLimitsSchema = z.object({
    plan: SubscriptionPlanNameSchema,
    order: z.number().int().nonnegative(),
    creditsPerMonth: z.number().int().nonnegative(),
    domains: z.number().int().nonnegative(),
    features: FeaturesSchema,
    bookable: z.boolean()
});
export type SubscriptionPlanLimits = z.infer<typeof SubscriptionPlanLimitsSchema>;
